import { SetAuth } from "../helpers/Auth";
import { getEnviroments } from "../helpers/enviroments";
import { FIDEICOMISOS, INVERSIONES_USUARIO } from "../constants/mockData";

// 🔥 Modo DEMO: Retorna datos mock en lugar de hacer llamadas al API
const DEMO_MODE = true;

export const getFunds = async () => {
  // 🔥 Modo DEMO
  if (DEMO_MODE) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(FIDEICOMISOS);
      }, 300); // Simular delay de red
    });
  }

  // Modo producción (comentado para demo)
  try {
    const auth = SetAuth();
    const token = auth?.token;
    const { DOMAIN } = getEnviroments();

    const url = `${DOMAIN}/fund/api/main/`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    return data.results;
  } catch (error) {
    console.error("Error al obtener los fondos:", error);
    throw error;
  }
};

export const fundInvestment = async () => {
  // 🔥 Modo DEMO
  if (DEMO_MODE) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(INVERSIONES_USUARIO);
      }, 300); // Simular delay de red
    });
  }

  // Modo producción (comentado para demo)
  try {
    const auth = SetAuth();
    const token = auth?.token;
    const { DOMAIN } = getEnviroments();

    const url = `${DOMAIN}/fund/api/investment/`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }
    const data = await response.json();
    return data.results;
  } catch (error) {
    console.error("Error al obtener los fondos:", error);
    throw error;
  }
}
